/**
 * Video-link detection for GN paste handling (spec 046 FR-003, research Decision 10).
 * YouTube is the v1 provider; the return shape leaves room for more.
 */

export interface ParsedVideoUrl {
  provider: 'youtube';
  videoId: string;
  originalUrl: string;
}

// watch?v=ID | youtu.be/ID | /embed/ID | /shorts/ID — ID is always 11 chars.
const YOUTUBE_PATTERNS = [
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/watch\?(?:[^ ]*&)?v=([A-Za-z0-9_-]{11})/,
  /(?:https?:\/\/)?youtu\.be\/([A-Za-z0-9_-]{11})/,
  /(?:https?:\/\/)?(?:www\.)?youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{11})/,
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/,
];

/**
 * Returns video info when the pasted text is (only) a supported video link — a URL pasted
 * inside a sentence is left alone, since the user is writing prose, not embedding.
 */
export function parseVideoUrl(pastedText: string): ParsedVideoUrl | null {
  const text = (pastedText || '').trim();
  if (!text || /\s/.test(text)) return null;

  for (const pattern of YOUTUBE_PATTERNS) {
    const match = text.match(pattern);
    if (match) {
      return { provider: 'youtube', videoId: match[1], originalUrl: text };
    }
  }
  return null;
}
